($ => {
  $(document).ready(() => {
    $('.dumel-video-slider').each((idx, slider) => {
      $(slider).find('.dumel-video-slider__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: `
          <button type="button" class="dumel-video-slider__nav dumel-video-slider__nav--prev">
            <svg version="1.1" id="Warstwa_1" x="0px" y="0px" viewBox="0 0 12.1 18.7" xml:space="preserve"
              class="dumel-video-slider__nav-arrow" fill="currentColor">
              <path class="st0" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
            c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
            s-0.7-0.1-1-0.4L0.4,10.4z" />
            </svg>
          </button>
        `,
        nextArrow: `
          <button type="button" class="dumel-video-slider__nav dumel-video-slider__nav--next">
            <svg version="1.1" id="Warstwa_1" x="0px" y="0px" viewBox="0 0 12.1 18.7" xml:space="preserve"
              class="dumel-video-slider__nav-arrow dumel-video-slider__nav-arrow--right" fill="currentColor" >
              <path class="st0" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
              c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
              s-0.7-0.1-1-0.4L0.4,10.4z" />
            </svg>
          </button>
        `,
        dots: true,
        appendDots: $('.dumel-video-slider__navigation-pagin'),
        customPaging: () => {
          return;
        },
      } as any);

      const popup = $(slider).find('.dumel-video-slider__popup-video');
      const videoClassName = 'popup-video';
      $(slider).find('.dumel-video-slider__player').each((index, button) => {
        $(button).click((e) => {
          const videoUrl = $(e.delegateTarget).parents('.dumel-video-slider__item').attr('data-video-url');
          $(popup).addClass('-active');
          $('body').addClass('no-scroll');
          const popupObject = $('<iframe width="70%" height="70%" src="' + videoUrl.replace('watch?v=', 'embed/') + '" ' +
                        'frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; ' +
                        'picture-in-picture" allowfullscreen class="' + videoClassName + '"></iframe>');
          $(popup).append(popupObject);
        });
      });
      $(popup).click(() => {
        $(popup).removeClass('-active');
        $('body').removeClass('no-scroll');
        popup.find('.' + videoClassName).remove();
      });
    });
  });
})(jQuery);
